// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import styled from "styled-components/macro"
import SvgIcon from "features/shared/SvgIcon"
import { t } from "@lingui/macro"

const Button = styled.button`
  vertical-align: top;
  color: ${({ theme }): string => theme.colors.dimGray};
  align-items: center;
  border-radius: 3px;
  width: 30px;
  transition: all .3s ease;

  &:hover {
    color: ${({ theme }): string => theme.colors.cinnabar};
    background-color: ${({ theme }): string => theme.colors.wispPink};
  }
`

const StyledTrashIcon = styled(SvgIcon)`
  width: ${({ theme }) => theme.iconSizeInButton};
  min-width: ${({ theme }) => theme.iconSizeInButton};
  height: ${({ theme }) => theme.iconSizeInButton};
`

type Props = {
  title?: string,
  className?: string,
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

const TrashIconButton = ({
  title = t({ id: "label_remove", message: "Remove" }),
  className,
  onClick,
}: Props): React.ReactElement<Props> => {
  return (
    <Button
      type="button"
      tabIndex={-1}
      className={className}
      onClick={onClick}
      title={title}
    >
      <StyledTrashIcon name="trash"/>
    </Button>
  )
}

export default TrashIconButton
